export default {"src":"/_next/static/media/target.7139ed40.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};